import React from 'react';
import { Menu, Phone, Mail } from 'lucide-react';
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import MobileMenuContent from './MobileMenuContent';
import { useTheme } from '@/contexts/ThemeContext';

interface MobileNavigationProps {
  isDarkSection: boolean;
}

const MobileNavigation: React.FC<MobileNavigationProps> = ({ isDarkSection }) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const bgColor = isDark ? '#1a1a1a' : '#FFFFFF';
  const borderColor = isDark ? '#333333' : '#E5E5E5';
  const labelColor = isDark ? '#888888' : '#888888';
  const titleColor = isDark ? '#FCFCF9' : '#111111';
  const descColor = isDark ? '#999999' : '#555555';
  const iconColor = isDark ? '#888888' : '#888888';

  return (
    <div className="block">
      <Sheet>
        <SheetTrigger asChild>
          <Button variant="ghost" size="icon" className="p-0" aria-label="Open navigation menu">
            <Menu 
              size={24} 
              className={`transition-all duration-300 ${
                isDarkSection ? 'text-white' : 'text-foreground'
              }`}
            />
          </Button>
        </SheetTrigger>
        <SheetContent 
          side="right" 
          className="w-full !h-auto max-h-screen overflow-y-auto"
          style={{ backgroundColor: bgColor }}
        >
          <SheetHeader>
            <SheetTitle className="text-left" style={{ color: titleColor }}>Navigation</SheetTitle>
            <SheetDescription className="sr-only">
              Mobile navigation menu
            </SheetDescription>
          </SheetHeader>
          
          <div className="my-4">
            <MobileMenuContent />
          </div>

          {/* Contact Info */}
          <div className="space-y-3 py-4 border-t" style={{ borderColor }}>
            <h3 className="text-[11px] font-medium uppercase tracking-wider" style={{ color: labelColor }}>
              Get in Touch
            </h3>
            <a 
              href="tel:+18885056258" 
              className="flex items-center gap-2 text-sm transition-colors hover:underline" 
              style={{ color: descColor }}
            >
              <Phone className="w-4 h-4" style={{ color: iconColor }} strokeWidth={1.5} />
              <span>(888) 505-6258</span>
            </a>
            <a 
              href="mailto:hello@storymarketing.group" 
              className="flex items-center gap-2 text-sm transition-colors hover:underline" 
              style={{ color: descColor }}
            >
              <Mail className="w-4 h-4" style={{ color: iconColor }} strokeWidth={1.5} />
              <span>hello@storymarketing.group</span>
            </a>
          </div>

          {/* Action Buttons */}
          <div className="space-y-3 pt-4 pb-6 border-t" style={{ borderColor }}>
            <Button 
              className="w-full font-medium" 
              size="lg"
              style={{ 
                backgroundColor: isDark ? '#FCFCF9' : '#1a1a1a',
                color: isDark ? '#111111' : '#FCFCF9'
              }}
              asChild
            >
              <a href="/pricing">14 Day Free Trial</a>
            </Button>
            <Button 
              className="w-full font-medium" 
              size="lg"
              variant="outline"
              style={{ 
                backgroundColor: 'transparent', 
                borderColor: isDark ? '#555555' : '#111111', 
                color: titleColor 
              }}
            >
              Sign In
            </Button>
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
};

export default MobileNavigation;
